import React, { forwardRef } from 'react'

import { IconProps } from './types'

const At = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1343 5.64465C10.6333 7.13729 9.63141 10.1225 11.6352 10.6201C14.1133 11.2356 15.8934 6.14182 11.8857 3.15683C7.62592 -0.0158521 1.04136 3.7857 2.117 9.12762C3.04825 13.7525 7.62758 15.0982 11.6352 13.108M10.1699 8.60447C9.74111 10.2049 8.31233 11.2126 6.97866 10.8552C5.645 10.4978 4.91148 8.91077 5.3403 7.31038C5.76913 5.70998 7.19791 4.70229 8.53157 5.05965C9.86524 5.417 10.5988 7.00407 10.1699 8.60447Z"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
At.displayName = 'At'

export default At
